import React from "react";
import { observer } from "mobx-react-lite";
import { PopupSendSuccess, PopupSendUnsuccess } from "./PopupSend";
import { advancePopup } from "./PopupAdvancePayment";
import { PopupWrapper } from "./Popup.styles";
import { useStore } from "../../store";

const Popup = () => {
  const { globalModule } = useStore();
    const {
        showAdvancePopup,
        showSendPopupSuccess,
        showSendPopupUnsuccess,
      } = globalModule;

      (showAdvancePopup || showSendPopupSuccess || showSendPopupUnsuccess)
        ? document.body.classList.add("popup-open")
        : document.body.classList.remove("popup-open");

    return (
      <PopupWrapper>
        {showAdvancePopup && advancePopup()}
        {showSendPopupSuccess && PopupSendSuccess()}
        {showSendPopupUnsuccess && PopupSendUnsuccess()}
      </PopupWrapper>
      );
};

export default observer(Popup);
